const routes = {
  adminLogin: '/ad-login',
  login: '/login',
  setupAccount: '/setup-account',
  resetPassword: '/reset-password',
  newPassword: '/new-password',
  adminPanel: {
    index: '/panel',
    decedents: `/panel/decedents`,
    accessCodes: '/panel/access-codes',
    resellers: '/panel/resellers',
    resellerNew: '/panel/resellers/new',
    resellerEdit: '/panel/resellers/:id',
    decedentProfile: `/panel/decedents/profile/`,
  },
  dashboard: {
    index: '/dashboard',
    profile: '/dashboard/profile',
    accountSettings: '/dashboard/account-settings',
    taskList: '/dashboard/task-list',
    editQuestions: '/dashboard/task-list/edit',
    taskDetails: '/dashboard/task-list/details',
    entryLists: '/dashboard/entry-lists',
    about: '/dashboard/about',
    generalNotes: '/dashboard/general-notes',

    finInstitutions: '/dashboard/fin-institutions',
    finInstitutionDetails: '/dashboard/fin-institutions/:institutionId',
  },
  decedentInitiation: '/decedent-initiation',
};

export default routes;
